import { MouseEvent, useState } from "react"
import sendMessage from "./sendMessage"
import { navigate } from "@reach/router"
import { INNOVATION_LAB_FORM } from "./innovation-lab.component"
import { Client } from "../../../../../internal-api/netlify"

const netlifyClient = new Client(process.env.GATSBY_SITE_URL!)

export const useLabForm = (): {
  sentForm: boolean
  submitAnotherIdea: (event: MouseEvent<HTMLDivElement>) => void
  onFormSubmit: (data: any) => Promise<void>
} => {
  const [sentForm, setSentForm] = useState(false)

  const submitAnotherIdea = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    setSentForm(false)
  }

  const onFormSubmit = async (data: any) => {
    await sendMessage(data)
    await netlifyClient.innovationLabForm.sendConfirmationEmail({
      email: data["E-mail address"],
      userName: data["First and Last Name"],
    })
    setSentForm(true)
    await navigate(`#${INNOVATION_LAB_FORM}`)
  }

  return {
    sentForm,
    submitAnotherIdea,
    onFormSubmit,
  }
}
